module.exports = __webpack_public_path__ + "images/Lock.8feb14157135f40b2699477f15152576.svg";